import { Link } from 'react-router-dom';
import SettingsMenu from '../../components/SettingsMenu';
import siteLogo from '../../images/logo-full-impact-v2-1.png';
import './Header.scss';

export default function Header() {

  return (
    <header className="mb-4">
      <div className="d-flex align-items-center container">
        <Link to='/'>
          <img src={siteLogo} className="site-logo" alt="Full Impact Training Logo" />
        </Link>

        <div>
          <svg xmlns="http://www.w3.org/2000/svg">
            <filter id="motion-blur-filter" filterUnits="userSpaceOnUse">
              <feGaussianBlur stdDeviation="100 0"></feGaussianBlur>
            </filter>
          </svg>
          <span className="title" filter-content="S">Schedule</span>
        </div>
      </div>
      <SettingsMenu />
    </header>
  );
}